export default __webpack_public_path__ + "static/media/gallery_06.f0c96211.jpg";